module.exports = __webpack_public_path__ + "static/img/Hamish_Stewart.2f38963.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Hamish_Stewart.jpg
// module id = xlMt
// module chunks = 0